import { useEffect } from 'react';

export const ClickLiveChatButton = ({ vId }: { vId: string }) => {
  useEffect(() => {
    const clickButtonIfExists = () => {
      const button = document.querySelector(`#${vId} button`) as HTMLButtonElement;

      if (button) {
        button.click();
        return true;
      }

      return false;
    };

    // Try clicking the button immediately in case it's already present
    if (clickButtonIfExists()) return;

    // Set up MutationObserver to watch for the button being added
    const observer = new MutationObserver(() => {
      if (clickButtonIfExists()) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Stop observing after 20 seconds
    const timeoutId = setTimeout(() => {
      observer.disconnect();
    }, 20000);

    // Cleanup
    return () => {
      observer.disconnect();
      clearTimeout(timeoutId);
    };
  }, []);

  return null; // This component does not render anything
};
